import React from 'react';
import { FormattedMessage } from 'react-intl';
import useTabFromUrl from '../../Components/ComponentsOfAdministrator/TerminalEditing/useTabFromUrl';
import TerminalEditing from '../../Components/ComponentsOfAdministrator/TerminalEditing';
import TerminalBalanceTab from '../../Components/TerminalBalanceTab';
import TerminalSettlementTab from '../../Components/TerminalSettlementTab';
import TerminalFeesTab from '../../Components/TerminalFeesTab';
import MerchantSettingsFeesTab from '../../Components/MerchantSettingsFeesTab';
import AntiFraudConfigTab from '../../Components/AntiFraudConfigTab';
import classes from './styles.module.css';

/**
 * Группирует все секции страницы выбранного терминала в 5 вкладок вместо
 * длинного скролла на 1500px.
 *
 * Распределение:
 *   - "Общее" → TerminalEditing (название, статус, ключи, методы, провайдер)
 *   - "Балансы" → TerminalBalanceTab + TerminalSettlementTab
 *   - "Комиссии" → TerminalFeesTab + MerchantSettingsFeesTab + MCC-подсказка
 *   - "Antifraud" → AntiFraudConfigTab
 *   - "Раздел избранного" → пока пусто, зарезервирован под будущие PSB-инструменты
 *
 * URL ?tab=... синхронизирован через useTabFromUrl: можно дать ссылку
 * другому админу прямо на нужный таб открытого терминала.
 *
 * Если терминал не выбран — показываем плейсхолдер (внутри TerminalEditing уже
 * есть own empty-state, но он сидит во вкладке "Общее"; вместо него — пустая
 * подсказка).
 */
const TABS = ['general', 'balances', 'fees', 'antifraud'];

export default function TerminalDetailsTabs({ token, terminal, onSaved }) {
    const [tab, setTab] = useTabFromUrl('general', TABS);

    const hasSelected = !!(terminal && terminal.id);

    const tabButton = (id, labelId, fallback) => (
        <button
            key={id}
            type="button"
            className={tab === id ? `${classes.Tab} ${classes.TabActive}` : classes.Tab}
            onClick={() => setTab(id)}
        >
            <FormattedMessage id={labelId} defaultMessage={fallback} />
        </button>
    );

    return (
        <React.Fragment>
            {hasSelected && (
                <div className={classes.TabsBar}>
                    {tabButton('general', 'Terminals.tab.general', 'Общее')}
                    {tabButton('balances', 'Terminals.tab.balances', 'Балансы')}
                    {tabButton('fees', 'Terminals.tab.fees', 'Комиссии')}
                    {tabButton('antifraud', 'Terminals.tab.antifraud', 'Антифрод')}
                </div>
            )}

            {(tab === 'general' || !hasSelected) && (
                <div className={classes.TabPane}>
                    <TerminalEditing token={token} terminal={terminal} onSaved={onSaved} />
                </div>
            )}

            {hasSelected && tab === 'balances' && (
                <div className={classes.TabPane}>
                    <TerminalBalanceTab token={token} terminal={terminal} />
                    <TerminalSettlementTab token={token} terminal={terminal} />
                </div>
            )}

            {hasSelected && tab === 'fees' && (
                <div className={classes.TabPane}>
                    <div className={classes.HintBox}>
                        💡{' '}
                        <FormattedMessage
                            id="Terminals.hint.mcc"
                            defaultMessage="MCC настраивается на уровне Merchant Settings (привязка терминала к мерчанту), а не на самом терминале. Один терминал может быть подключен к нескольким мерчантам с разным MCC."
                        />
                    </div>
                    <TerminalFeesTab token={token} terminal={terminal} />
                    <MerchantSettingsFeesTab token={token} terminal={terminal} />
                </div>
            )}

            {hasSelected && tab === 'antifraud' && (
                <div className={classes.TabPane}>
                    <AntiFraudConfigTab token={token} terminal={terminal} />
                </div>
            )}
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/Terminals/TerminalDetailsTabs.js